import React from 'react';
import { Mail, Linkedin, Github } from 'lucide-react';

export const EMAIL = 'renanferreira.engineer@gmail.com';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/renansfrr/';
export const GITHUB_URL = 'https://github.com/renansfr';

const LINKS = [
  { href: `mailto:${EMAIL}`, icon: Mail, label: 'Email' },
  { href: LINKEDIN_URL, icon: Linkedin, label: 'LinkedIn' },
  { href: GITHUB_URL, icon: Github, label: 'GitHub' },
];

interface SocialLinksProps {
  size?: number;
  className?: string;
  /** Boxed renders each icon in a bordered tile; plain renders a bare icon row. */
  variant?: 'boxed' | 'plain';
}

const SocialLinks: React.FC<SocialLinksProps> = ({
  size = 18,
  className = '',
  variant = 'plain',
}) => {
  const isBoxed = variant === 'boxed';

  return (
    <div className={`flex ${isBoxed ? 'gap-2.5' : 'gap-4'} ${className}`}>
      {LINKS.map(({ href, icon: Icon, label }) => {
        const isExternal = href.startsWith('http');

        return (
          <a
            key={label}
            href={href}
            target={isExternal ? '_blank' : undefined}
            rel={isExternal ? 'noopener noreferrer' : undefined}
            aria-label={label}
            className={
              isBoxed
                ? 'flex items-center justify-center w-10 h-10 rounded-lg border border-dark-border bg-dark-surface text-dark-muted transition duration-300 ease-out-soft hover:-translate-y-0.5 hover:text-accent hover:border-accent/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-dark-bg'
                : 'text-dark-muted transition-colors duration-200 hover:text-accent focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-dark-bg rounded'
            }
          >
            <Icon size={size} />
          </a>
        );
      })}
    </div>
  );
};

export default SocialLinks;
